import type { Input } from '@gonfalon/openapi/operations/putMemberDismissal';
import { putMemberDismissal } from '@gonfalon/openapi/operations/putMemberDismissal';
import { getQueryClient } from '@gonfalon/react-query-client/getQueryClient';

import { createMutationHook } from '../internal/createMutationHook';
import { getMemberDismissalsQuery } from '../queries/memberDismissals';

export const useMarkDismissed = createMutationHook(
  (input: Input) => putMemberDismissal(input, { headers: { 'Content-Type': 'application/json' } }),
  {
    onSuccess: (data) => {
      const queryClient = getQueryClient();
      // The PUT returns the member's full dismissals map; seed the query cache so the
      // UI hides immediately and won't re-trigger within the session.
      queryClient.setQueryData(getMemberDismissalsQuery().queryKey, data);
    },
  },
);
